import { DataFromUrl, Fb, JobSharing, handleOtherResponseCode, Image, Li, startDateMessage, SUCCESS_REPONSE_CODE, toastr, Twi,
         UNPROCESSABLE_ENTITY_RESPONSE_CODE, REDIRECT, CustomToastrAction, PageStyle, Button, ButtonStyle, cursorNone, useTranslation, 
         TRANSLATION} from  '@/imports-files/pages/clients/jobs/job-sharing';

  export function getActiveIds(freeJobBoards, paidJobBoards, socialSharings){
    let active_ids = [];
    freeJobBoards.enabled.map((x) => { if(x.active) active_ids.push(x.id.toString()); return x; })
    paidJobBoards.enabled.map((x) => { if(x.active) active_ids.push(x.id.toString()); return x; })
    socialSharings.enabled.map((x) => { if(x.active) active_ids.push(x.id.toString()); return x; })
    return active_ids;
  }

  export function handleActiveJobBoard(
    e,
    formik,
    setConfirmationModal,
    t
  ) {
    let data_id = e.target.getAttribute("data-id");
    let integration_ids = formik.values.job.integration_ids;
    let data_post_type = e.target.getAttribute("data-board-type");
    if (e.target.checked && integration_ids.includes(data_id)) {
      setConfirmationModal({
        state: true,
        message: `${t("modal:confirmation:activeJobBoard:active_linkedIn_jobs")} ${
          data_post_type == "free" ? t("modal:confirmation:activeJobBoard:premium") : t("modal:confirmation:activeJobBoard:basic")
        } ${t("modal:confirmation:activeJobBoard:proceed")}`,
        

        integration_id: data_id,
        data_post_type: data_post_type,
      });
    }
    if (e.target.checked) {
      integration_ids.push(data_id);
      formik.setFieldValue("job.linkedin_post_type", data_post_type);
    } else {
      let index = integration_ids.indexOf(data_id);
      integration_ids.splice(index, 1);
    }
  }


  export const updateJobBoardState = (
    formRef,
    checkboxRefs,
    valueToUncheck,
    currentPostType,
    indexToSplice
  ) => {
    const integration_ids = formRef.current.values.job.integration_ids;
    const index = integration_ids.indexOf(indexToSplice);
    if (index !== -1) {
      integration_ids.splice(index, 1);
    }
    formRef.current.setFieldValue("job.integration_ids", [...integration_ids]);
    formRef.current.setFieldValue("job.linkedin_post_type", currentPostType);

    if (checkboxRefs.current[`${valueToUncheck}_${indexToSplice}`]) {
      checkboxRefs.current[`${valueToUncheck}_${indexToSplice}`].checked = false;
    }
  };

  export function socialIcons(integration_name){
    let image = '';
    switch(integration_name){
      case 'facebook':
        image = <Image src={Fb} alt=''></Image>
        break;
      case 'linkedin_feed_post':
        image = <Image src={Li} alt=''></Image> 
        break;
      case 'twitter':
        image = <Image src={Twi} alt=''></Image> 
        break;
    }
    return image;
  }



export async function handleJobSharingFormSubmit(params, router, setPageNamem, queryClient, setJobLivePopup, setJobSlug, setClientSlug, setJobTitle, showLivePopup, fromKanban, setDisabledSaveButton, jobForApprove, t)
{
    setDisabledSaveButton(true);
    // var job_id   =  window.location.pathname.split('/').slice(-2)[0];
    var job_id          =   new DataFromUrl().getJobId();
    const result        =   await new JobSharing().addJobBoards(params, job_id);
    const status_code   =   result.status || result.response.status;
    const customToastrAction  =   new CustomToastrAction(); 
    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
      const response            =   result.data;
      // TODO:- Remove the jobdata cache when the redirection is set
      // toastr.success(response.success)
      setJobSlug(response.slug)
      setClientSlug(response.client_slug)
      setJobTitle(response.job_title)

      if(showLivePopup && !jobForApprove)
      {
        setJobLivePopup(true);
        setDisabledSaveButton(false);
      } 
      else
      {

        if(jobForApprove)
        { 
          customToastrAction.setNormalToastr(response.success);
          router.push(router.push({pathname: REDIRECT.client.jobs.index, query: {job_type: 'active'}}))
        }

        else{
        customToastrAction.setNormalToastr(`${response.job_title} ${t('jobs:update_message')}`, 'success');
      }
        //  toastr.success(`${response.job_title}  is updated successfully.`)
         if(fromKanban)
         {
          setTimeout(() => router.push({pathname: REDIRECT.client.kanban_board.replace('$job_id', job_id)}), 50)
         }
         else
         {
          setTimeout(() => router.push({pathname: REDIRECT.client.jobs.index, query: {job_type: 'active'}}), 50)
         } 
      }
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      let message = "";
      if(result.response.data.error.job?.base) { message = startDateMessage(message, result.response.data.error.job?.base)}
      if(message.length > 0)
      {
        customToastrAction.setNormalToastr(message, 'warning');
      }
       setDisabledSaveButton(false);
      break;
    default: 
      handleOtherResponseCode(status_code, router);
       setDisabledSaveButton(false);
    }
   
  } 


  export async function getJobSharingData(router, setApiError)
  {
    var job_id                =   new DataFromUrl().getJobId();
    const result              =   await new JobSharing().getJobBoards(job_id);
    const status_code         =   result.status || result.response.status;
    const customToastrAction  =   new CustomToastrAction(); 

    if(result.request.status == 200){
      return result.data;
    }
    else{
      setApiError(result.request)
    }
  }

  export async function getAgencyUsers(name_or_email, router, domain)
  {
    const body                =   {name_or_email: name_or_email, domain}
    const result              =   await new JobSharing().getUserByNameOrEmail(body);
    const status_code         =   result.status || result.response.status;
    const customToastrAction  =   new CustomToastrAction(); 
    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
      const response = result.data;
      return response.users
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'warning');
      return []
    default: 
      handleOtherResponseCode(status_code, router);
    }
  }

  export async function getAgencyOrClientUsers(name_or_email, router, domain)
  {
    const body                =   {name_or_email: name_or_email, domain}
    const result              =   await new JobSharing().getAgencyOrClientUserByNameOrEmail(body);
    const status_code         =   result.status || result.response.status;
    const customToastrAction  =   new CustomToastrAction();
    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
      const response = result.data;
      return response.users
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'warning');
      return []
    default:
      handleOtherResponseCode(status_code, router);
    }
  }
  
  export function shouldRenderSuggestions(value){
    return value.trim().length >= 3
  }
  export const renderInputComponent = inputProps => (
  <div className="buttonIn AutoSuggestInput__Tags">
    {inputProps.selectedValues?.map((item, index) => (
      <div className={PageStyle.Tagrow__Tags} key={`agency_user_${index}`}>
        {/* Uncomment if you need to display photo URL or initials */}
        {/* item?.photo_url ?
          <img src={item?.photo_url} className="JobImageSmall" />
          : item.name_initials && <div className={PageStyle.Tagrow__Prefix}>{item.name_initials}</div> */}

        {item.name ? <span>{item.name}</span> : <span>{item.email}</span>}
        {inputProps.editable && (
          <button
            type="button"
            className={PageStyle.Tagrow__Cancel}
            onClick={() => {
              if (inputProps.initialAgencyUserEmails.includes(item.email)) {
                inputProps.setConfirmation({ state: true, formik: inputProps.formik, index: inputProps.index });
              } else {
                inputProps.handleEmailDelete(inputProps.formik, inputProps.index);
              }
            }}
          >
            {inputProps.closeIcon}
          </button>
        )}
      </div>
    ))}
    <input className = {PageStyle.Form__Input} autoComplete={"password"}
      {...inputProps} />
    <Button buttonstyle={`${ButtonStyle.nobgbutton} addbtn ${cursorNone(inputProps.editable)}`} disabled={inputProps.disabled} onClick={() => onAddClick(event, inputProps)}>{inputProps.t('button:add:default')}</Button>
  </div>
);

  
  export function getUserSuggestionValue(suggestion) 
  {
    return `${suggestion.user_attributes.email}`;
  }
  
  function showSuggestion(suggestion){
    if(suggestion.user_attributes.name && (suggestion.user_attributes.email.length > 0)){
      return `${suggestion.user_attributes.name} | ${suggestion.user_attributes.email}`
    }
    else if(suggestion.user_attributes.name){
      return `${suggestion.user_attributes.name}`
    }
    else{
      return `${suggestion.user_attributes.email}`
    }
  }
    
    export function renderUserSuggestion(suggestion) {
      return (
        <span>{showSuggestion(suggestion)}</span>
      );
    }

    function escapeRegexCharacters(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    async function getUserSuggestions(value, router) {
      const escapedValue = escapeRegexCharacters(value?.trim());
      
      if (escapedValue === '') {
      return [];
      }
      let finalUsers = await getAgencyUsers(escapedValue, router)
      return finalUsers
    }
    
    export async function onUserSuggestionsFetchRequested(hash, setUsers){    
      let users = await getUserSuggestions(hash.value)
      setUsers(users)
    };
    
    export const onUserSuggestionsClearRequested = (setUsers) => {
      setUsers([])
    };
    
    export function isEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
    }

    export function onUserSuggestionSelection(formik, old_emails, email, old_initials, new_initial){
      if(isEmail(email) && !old_emails.includes(email))
      {
        old_emails.unshift(email)
        old_initials.unshift(new_initial) 
      }
    }

    export async function handleKeyDown(evt, formik, setAgencyUserEmail, setAgencyUserError, t, params){
      if (["Enter"].includes(evt.key)) {
        evt.preventDefault();
        let email = evt.target.value
        if(isEmail(email))
        {
          let data = await checkAgencyUserExisting(email);
          if(data.new_user){
            params.setAddAgencyModal({state: true, data: { onUserSuggestionSelection: onUserSuggestionSelection, params: params }})
          }else{
            {
              if(!data.deactivated_agency) onUserSuggestionSelection(params.formik, params.formik.values.job.agency_user_emails, email, params.formik.values.job.agency_user_initials, {email: email, name_initials: null, name: null})
              params.setAgencyUserEmail('')
            }
          }
        }
        else
        {
          setAgencyUserError(t("errors:autocomplete_invalid_email"));
        }
      };
    }

    const onAddClick = async (event, params) => {
      let email = params.value
      if(isEmail(email))
      {
        let data = await checkAgencyUserExisting(email);
        if(data.new_user){
          params.setAddAgencyModal({state: true, data: { onUserSuggestionSelection: onUserSuggestionSelection, params: params }})
        }else{
          {
            if(!data.deactivated_agency) onUserSuggestionSelection(params.formik, params.formik.values.job.agency_user_emails, email, params.formik.values.job.agency_user_initials, {email: email, name_initials: null, name: null})
            params.setAgencyUserEmail('')
          }
        }
      }
      else
      {
        params.setAgencyUserError(params.t("errors:autocomplete_invalid_email"));
      }
    }


    export async function checkAgencyUserExisting(email){
      const body                =   {email: email}
      const result              =   await new JobSharing().checkAgencyUserExist(body);
      const status_code         =   result.status || result.response.status;
      const customToastrAction  =   new CustomToastrAction();
      switch (status_code)
      {
      case SUCCESS_REPONSE_CODE:
        return result.data
      case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        customToastrAction.setNormalToastr(result.response.data.error, 'warning');
        return result.response.data
      default:
      handleOtherResponseCode(status_code, router);
      }
    }

    export async function submitAgencyResponse(params, addAgencyModal, setAddAgencyModal, job_id){
      params.user_email         =   addAgencyModal.data.params.value
      params.job_id             =   job_id
      const body                =   params
      const result              =   await new JobSharing().addAgencyUserResponse(body, job_id);
      const status_code         =   result.status || result.response.status;
      const customToastrAction  =   new CustomToastrAction();
      switch (status_code)
      {
      case SUCCESS_REPONSE_CODE:
        addAgencyModal.data.onUserSuggestionSelection(addAgencyModal.data.params.formik, addAgencyModal.data.params.formik.values.job.agency_user_emails, body.user_email, addAgencyModal.data.params.formik.values.job.agency_user_initials, {email: body.user_email, name_initials: null, name: null});
        addAgencyModal.data.params.setAgencyUserEmail('');
        setAddAgencyModal({state: false, data: {}});
        customToastrAction.setNormalToastr(result.data.success, 'success');
      case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        setAddAgencyModal({state: false, data: {}});
        customToastrAction.setNormalToastr(result.response.data.error, 'warning');
      default:
        customToastrAction.setNormalToastr(result.response.data.error, 'warning');
        handleOtherResponseCode(status_code, router);
      }
    }

    export function handleEmailDelete(formik, itemIndex )
    {
      let emails = formik.values.job.agency_user_emails 
      let name_initials = formik.values.job.agency_user_initials
      emails.splice(itemIndex, 1)
      name_initials.splice(itemIndex, 1)
      formik.setFieldValue(`job.agency_user_emails`, [...emails])
      formik.setFieldValue(`job.agency_user_initials`, [...name_initials])
    }

    
    export function isJobForApproval(data)
    {
       return data.job_status!='Published' && data.required_approvers !=0 
    }